import React from "react";
import {connect} from "react-redux";
import Rdx from "../../../../../redux/Rdx";

import OtherBookings from "./OtherBookings";
import MyBookings from "./MyBookings";

class BookingsTab extends React.Component {

    renderBookings =()=> {
        if(this.props.rdxTabSelected === "self") {
            return <MyBookings bookingDateFilter={this.props.bookingDateFilter}/>
        } else if (this.props.rdxTabSelected === "others") {
            return <OtherBookings bookingDateFilter={this.props.bookingDateFilter}/>
        } else {
            return null;
        }
    }

    render() { 
        return (this.renderBookings());
    }
}

const mapStateToProps = (state) => {
    return {
      rdxDateOption: Rdx.getValue(state,Rdx.Keys.BOOK_DATEFILTER_OPTION),
      rdxDateSelected: Rdx.getValue(state,Rdx.Keys.BOOK_DATEFILTER_DATESELECTED),
      rdxTabSelected: Rdx.getValue(state, Rdx.Keys.BOOK_TAB_SELECTED)
    }
  }
  
export default connect(mapStateToProps)(BookingsTab);